import React from 'react';

const UpgradeLock = () => (
  <svg
    className="transfer__option-lock"
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="28" height="28" rx="14" fill="#FCB315" />
    <g clipPath="url(#clip0_4415_69268)">
      <path
        d="M18.3095 13.1665H10.6905C9.84892 13.1665 9.16669 13.8629 9.16669 14.7221V19.3887C9.16669 21.1069 10.5312 22.4998 12.2143 22.4998H16.7857C18.4689 22.4998 19.8334 21.1069 19.8334 19.3887V14.7221C19.8334 13.8629 19.1511 13.1665 18.3095 13.1665Z"
        fill="white"
      />
      <path
        d="M11.0833 13.8335C11.0833 14.2477 11.4191 14.5835 11.8333 14.5835C12.2475 14.5835 12.5833 14.2477 12.5833 13.8335H11.0833ZM16.4166 13.8335C16.4166 14.2477 16.7524 14.5835 17.1666 14.5835C17.5809 14.5835 17.9166 14.2477 17.9166 13.8335H16.4166ZM12.5833 13.8335V10.5002H11.0833V13.8335H12.5833ZM16.4166 10.5002V13.8335H17.9166V10.5002H16.4166ZM14.5 8.5835C15.5585 8.5835 16.4166 9.44162 16.4166 10.5002H17.9166C17.9166 8.61319 16.387 7.0835 14.5 7.0835V8.5835ZM14.5 7.0835C12.613 7.0835 11.0833 8.61319 11.0833 10.5002H12.5833C12.5833 9.44162 13.4414 8.5835 14.5 8.5835V7.0835Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4415_69268">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(6.5 6.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default UpgradeLock;
